import { useTheme } from "./useTheme";
import type { ThemeChoice } from "./theme";

const CHOICES: ThemeChoice[] = ["system", "light", "dark"];

const LABELS: Record<ThemeChoice, string> = {
  system: "跟随系统",
  light: "亮色",
  dark: "暗色",
};

/**
 * Spec §5.3: three-way theme switcher (system / light / dark) that persists
 * the user's choice. Renders inline in the console header.
 */
export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  return (
    <div role="group" aria-label="主题切换" className="flex gap-1 text-xs">
      {CHOICES.map((choice) => (
        <button
          key={choice}
          type="button"
          onClick={() => setTheme(choice)}
          aria-pressed={theme === choice}
          className={
            "rounded border px-2 py-1 " +
            (theme === choice
              ? "border-neutral-900 bg-neutral-900 text-white"
              : "border-neutral-300 text-neutral-700 hover:bg-neutral-100")
          }
        >
          {LABELS[choice]}
        </button>
      ))}
    </div>
  );
}
